// extracted by mini-css-extract-plugin
export var categories = "CategorySection-module--categories--dYf0z";
export var categoryCards = "CategorySection-module--categoryCards--1dedQ";